const SHOP_TOPUP_RESUME_KEY = 'replayer.shopTopupResume';
const SHOP_TOPUP_RESUME_MAX_AGE_MS = 2 * 60 * 60 * 1000;

const sessionStorageFor = storage => storage || window.sessionStorage;

const isSafeShopReturnPath = path => {
  if (typeof path !== 'string') return false;
  try {
    const url = new URL(path, 'https://replayer.local');
    const validPath = url.pathname === '/shop' || /^\/shop\/[A-Za-z0-9_-]+$/.test(url.pathname);
    return url.origin === 'https://replayer.local' &&
      validPath &&
      url.searchParams.get('shopResume') === '1' &&
      url.hash === '#shop-cart';
  } catch (error) {
    return false;
  }
};

export const suggestedShopTopupAmount = (totalCents, walletCents) => Math.max(
  5,
  Math.ceil(Math.max(0, Number(totalCents || 0) - Number(walletCents || 0)) / 100)
);

export const shopReturnPath = partnerSlug => (
  partnerSlug
    ? `/shop/${encodeURIComponent(partnerSlug)}?shopResume=1#shop-cart`
    : '/shop?shopResume=1#shop-cart'
);

export const saveShopTopupResume = (data, storage) => {
  if (!data || !isSafeShopReturnPath(data.returnPath)) return false;
  try {
    sessionStorageFor(storage).setItem(SHOP_TOPUP_RESUME_KEY, JSON.stringify({
      ...data,
      savedAt: Date.now()
    }));
    return true;
  } catch (error) {
    return false;
  }
};

export const getShopTopupResume = storage => {
  try {
    const target = sessionStorageFor(storage);
    const value = target.getItem(SHOP_TOPUP_RESUME_KEY);
    if (!value) return null;
    const resume = JSON.parse(value);
    const expired = !resume.savedAt || Date.now() - Number(resume.savedAt) > SHOP_TOPUP_RESUME_MAX_AGE_MS;
    if (expired || !isSafeShopReturnPath(resume.returnPath)) {
      target.removeItem(SHOP_TOPUP_RESUME_KEY);
      return null;
    }
    return resume;
  } catch (error) {
    return null;
  }
};

export const clearShopTopupResume = storage => {
  try {
    sessionStorageFor(storage).removeItem(SHOP_TOPUP_RESUME_KEY);
  } catch (error) {
    // The cart remains available in local storage when session storage is unavailable.
  }
};
